import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initAutoUpdate } from "@/lib/appUpdate";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Enregistrement du Service Worker + mise à jour automatique de l'app (PWA).
// Plus besoin de désinstaller/réinstaller : à chaque déploiement, l'app se
// recharge automatiquement (HTML network-first + détection de nouvelle version).
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    initAutoUpdate();
  });
}
